export const isFileFormatValid = ({
  file,
  acceptedTypes,
}: {
  file: File;
  acceptedTypes?: string[];
}) => {
  if (!acceptedTypes || !acceptedTypes.length) return true;

  return acceptedTypes.some(acceptedType => {
    if (acceptedType.endsWith("/*")) {
      const mimeFamily = acceptedType.slice(0, -1);
      return file.type.startsWith(mimeFamily);
    }

    return file.type === acceptedType || file.name.endsWith(acceptedType);
  });
};
